import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgLucideArchive = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <g
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    >
      <rect width={20} height={5} x={2} y={3} rx={1} />
      <path d="M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8m-10 4h4" />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgLucideArchive);
const Memo = memo(ForwardRef);
export default Memo;
